"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es.array.push.js");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      "remote-method": _vm.fetchClientList,
      filterable: "",
      clearable: "",
      "default-first-option": "",
      remote: "",
      placeholder: _vm.$t("lead.client")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.clientId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "clientId", $$v);
      },
      expression: "listQuery.clientId"
    }
  }, _vm._l(_vm.clientList, function (client) {
    return _c("el-option", {
      key: client.id,
      attrs: {
        value: client.id,
        label: client.name
      }
    });
  }), 1), _c("el-input", {
    staticClass: "filter-item",
    style: {
      width: Math.max(160, (_vm.listQuery.id ? String(_vm.listQuery.id).length * 9 : 0) + 40) + "px"
    },
    attrs: {
      placeholder: "Lead ID",
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.id,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "id", $$v);
      },
      expression: "listQuery.id"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      "remote-method": _vm.fetchClientContactList,
      filterable: "",
      clearable: "",
      "default-first-option": "",
      remote: "",
      placeholder: _vm.$t("lead.contact")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.clientsContactId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "clientsContactId", $$v);
      },
      expression: "listQuery.clientsContactId"
    }
  }, _vm._l(_vm.clientContactList, function (contact) {
    return _c("el-option", {
      key: contact.id,
      attrs: {
        value: contact.id,
        label: contact.firstName + " " + contact.lastName
      }
    });
  }), 1), _vm.adminType === "Sales Coordinator" ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: "Sales Manager",
      filterable: "",
      clearable: "",
      remote: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.salesManagerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "salesManagerId", $$v);
      },
      expression: "listQuery.salesManagerId"
    }
  }, _vm._l(_vm.salesManagerList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.fullName,
        value: item.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      "remote-method": _vm.fetchProductList,
      filterable: "",
      clearable: "",
      remote: "",
      placeholder: "Product Name",
      "popper-append-to-body": true,
      "popper-class": "responsive-select-dropdown"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.productId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "productId", $$v);
      },
      expression: "listQuery.productId"
    }
  }, _vm._l(_vm.productList, function (product) {
    return _c("el-option", {
      key: product.id,
      attrs: {
        value: product.id,
        label: product.name
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: _vm.$t("lead.source"),
      clearable: "",
      filterable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.sourceId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "sourceId", $$v);
      },
      expression: "listQuery.sourceId"
    }
  }, _vm._l(_vm.sourceList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1), _c("VueCtkDateTimePicker", {
    staticClass: "filter-item date-picker",
    attrs: {
      range: true,
      left: true,
      color: _vm.$primaryColor,
      formatted: "DD-MM-YYYY hh:mm a"
    },
    on: {
      "is-hidden": _vm.handleFilter
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: "Status",
      clearable: "",
      filterable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.status,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "status", $$v);
      },
      expression: "listQuery.status"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c("el-option", {
      key: item.name,
      attrs: {
        label: item.name,
        value: item.value
      }
    });
  }), 1), _c("div", {
    staticClass: "filter-actions"
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "action-btn",
    attrs: {
      type: "info",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _vm.isAdmin ? _c("router-link", {
    staticClass: "action-btn-link",
    attrs: {
      to: "/leads/add/"
    }
  }, [_c("el-button", {
    staticClass: "action-btn",
    attrs: {
      type: "warning",
      size: "small",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " ")])], 1) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "table-responsive"
  }, [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      "min-width": "50",
      align: "center",
      label: "ID",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.id
          }
        }, [_c("el-link", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v(" # " + _vm._s(scope.row.id) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "130",
      label: "Client",
      prop: "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$client, _scope$row$clientsCon, _scope$row$clientsCon2;
        return [_c("el-button", {
          staticClass: "company-name",
          attrs: {
            type: "text",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-office-building"
        }), _vm._v(" " + _vm._s((_scope$row$client = scope.row.client) === null || _scope$row$client === void 0 ? void 0 : _scope$row$client.name) + " ")]), _c("br"), _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          }
        }, [_c("i", {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(((_scope$row$clientsCon = scope.row.clientsContact) === null || _scope$row$clientsCon === void 0 ? void 0 : _scope$row$clientsCon.firstName) + " " + ((_scope$row$clientsCon2 = scope.row.clientsContact) === null || _scope$row$clientsCon2 === void 0 ? void 0 : _scope$row$clientsCon2.lastName)) + " ")]), _c("br"), scope.row.clientsContact.designation ? _c("span", [_c("i", {
          staticClass: "el-icon-suitcase"
        }), _c("i", [_vm._v(" " + _vm._s(scope.row.clientsContact.designation) + " ")])]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "80",
      label: "Team"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_c("span", [_vm._v(" " + _vm._s(_vm.getTeamInfo(row)) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "150",
      label: "Specs"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$source;
        return [scope.row.source ? _c("div", [_vm._v(" Source: " + _vm._s((_scope$row$source = scope.row.source) === null || _scope$row$source === void 0 ? void 0 : _scope$row$source.name) + " ")]) : _vm._e(), scope.row.comments ? _c("div", [_vm._v(" Comments: " + _vm._s(scope.row.comments) + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "100",
      align: "center",
      label: "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.productAction) + " "), _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "There are no further followups associated with this inquiry",
            placement: "top"
          }
        }, [scope.row.noFollowup ? _c("div", {
          staticClass: "status-Contacted"
        }, [_vm._v(" No Followup ")]) : _vm._e()]), _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "There are followups in this inquiry which are missed",
            placement: "top"
          }
        }, [scope.row.missedFollowUp ? _c("div", {
          staticClass: "status-Lost"
        }, [_vm._v(" Missed ")]) : _vm._e()])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "160",
      align: "center",
      label: "Products Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.leadsProduct && scope.row.leadsProduct.length > 0 ? _c("div", [_vm._l(scope.row.leadsProduct.slice(0, 2), function (product) {
          return _c("el-tooltip", {
            key: product.id,
            attrs: {
              content: product.productName,
              placement: "top"
            }
          }, [_c("el-tag", {
            staticClass: "product-tag",
            attrs: {
              type: "info"
            }
          }, [_vm._v(" " + _vm._s(product.productName) + " ")])], 1);
        }), scope.row.leadsProduct.length > 2 ? _c("el-tag", {
          staticClass: "more-tag",
          attrs: {
            type: "info"
          },
          on: {
            click: function ($event) {
              return _vm.openProductDialog(scope.row.leadsProduct);
            }
          }
        }, [_vm._v(" +" + _vm._s(scope.row.leadsProduct.length - 2) + " ")]) : _vm._e()], 2) : _c("div", [_vm._v(" NA ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "90",
      align: "center",
      label: "Budget",
      prop: "budget",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [parseFloat(scope.row.budget) > 0 ? _c("div", [_vm._v(" ₹ " + _vm._s(parseFloat(scope.row.budget).toLocaleString("en-IN")) + " ")]) : _c("div", [_vm._v(" NA ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "150",
      label: "Requirements"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v("Quantity: " + _vm._s(scope.row.quantity))]), parseFloat(scope.row.budgetPerPiece) > 0 ? _c("div", [_vm._v(" Budget Per Piece: "), _c("inr", {
          attrs: {
            number: scope.row.budgetPerPiece
          }
        })], 1) : _vm._e(), _c("div", [_vm._v(" Delivery Duration: " + _vm._s(scope.row.tentativeDeliveryDuration) + " (days) ")]), _c("div", [_vm._v(" Closure Dt: " + _vm._s(_vm._f("moment")(scope.row.expectedClosureDate, "DD-MM-YYYY")) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "100",
      align: "center",
      label: "Status",
      prop: "status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm.getStatusInfo(scope.row.status),
            placement: "top"
          }
        }, [_c("div", {
          class: "status-" + scope.row.status
        }, [_vm._v(" " + _vm._s(scope.row.status) + " ")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "130",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-dropdown", {
          staticClass: "actions-split-btn",
          attrs: {
            "split-button": "",
            trigger: "click",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push("/follow-ups/list/" + scope.row.id);
            }
          }
        }, [_vm._v(" Follow Up "), _c("el-dropdown-menu", {
          staticClass: "bharatflame-dropdown",
          attrs: {
            slot: "dropdown"
          },
          slot: "dropdown"
        }, [_vm.canReopen(scope.row) ? _c("el-dropdown-item", {
          staticClass: "reopen-item"
        }, [_c("span", {
          staticClass: "dropdown-link reopen-link",
          on: {
            click: function ($event) {
              return _vm.reopenLead(scope.row.id);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-refresh"
        }), _vm._v(" Reopen Lead ")])]) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "All Products",
      visible: _vm.productDialogVisible,
      width: "400px",
      "custom-class": "responsive-dialog"
    },
    on: {
      "update:visible": function ($event) {
        _vm.productDialogVisible = $event;
      }
    }
  }, [_vm.selectedProducts.length > 0 ? _c("div", _vm._l(_vm.selectedProducts, function (product) {
    return _c("el-tag", {
      key: product.id,
      staticClass: "dialog-product-tag",
      attrs: {
        type: "info"
      }
    }, [_vm._v(" " + _vm._s(product.productName) + " ")]);
  }), 1) : _vm._e(), _c("span", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.productDialogVisible = false;
      }
    }
  }, [_vm._v("Close")])], 1)]), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;